import React from 'react';
import {
  useNavigate,
  useLocation,
} from 'react-router-dom';
import {
  SecondaryAppBar, OutlinedIcons, useApiClient, useFetch,
} from '@marageti/z4-lib';
import { Container, IconButton } from '@mui/material';
import { TripHistories } from '@marageti/z4-sdk/lib/travel';
import ArchivedTripsView from './archived-trips-view';
import { useAuthStore } from '../../store';

const ArchivedTripsContainer = () => {
  const { loggedInTraveler } = useAuthStore();
  const apiClient = useApiClient();
  const travelerId = loggedInTraveler?.id;
  const location = useLocation();
  const routeArchivedTrips = location.state?.archivedTrips;

  const {
    data: tripsData,
    isLoading,
    error,
  } = useFetch<TripHistories>(
    apiClient.peopleClient.getTravelerTripHistories,
    [travelerId],
    !!travelerId && !routeArchivedTrips,
  );

  const archivedTrips = routeArchivedTrips || tripsData?.archivedTrips || [];

  const navigate = useNavigate();
  const goBack = () => navigate('/trip-requests');

  return (
    <>
      <SecondaryAppBar
        startAdornment={(
          <IconButton onClick={goBack}>
            <OutlinedIcons.OutlinedArrowLeftIcon color="primary" />
          </IconButton>
        )}
      />
      <Container
        maxWidth="md"
        sx={{ pb: 8 }}
      >
        <ArchivedTripsView
          trips={archivedTrips}
          loading={isLoading && !routeArchivedTrips}
          error={error}
        />
      </Container>
    </>
  );
};

export default ArchivedTripsContainer;
